import type { ForgeUIExtensionType } from '@atlassian/forge-ui-types/extension';

export const getDynamicConnectModuleKey = (
	extension: ForgeUIExtensionType,
	extensionIdWithoutPrefix: string,
): string | undefined => {
	const segments = extensionIdWithoutPrefix.split('/');
	if (segments.length !== 4 || segments.some((segment) => !segment)) {
		return undefined;
	}
	const [appId, environmentId, installationId, moduleKey] = segments;
	// Dynamic IDs use the installation ID where static IDs use "static". Verify that
	// association before using a bare key to resolve content created by another provider.
	if (installationId === 'static' || installationId !== extension.installationId) {
		return undefined;
	}
	if (
		(extension.appId !== undefined && extension.appId !== appId) ||
		(extension.environmentId !== undefined && extension.environmentId !== environmentId) ||
		(extension.key !== undefined && extension.key !== moduleKey)
	) {
		return undefined;
	}
	return moduleKey;
};
